import { render, staticRenderFns } from "./Authorise.vue?vue&type=template&id=4ce0b623&"
import script from "./Authorise.vue?vue&type=script&lang=js&"
export * from "./Authorise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports